var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7284 31.2415L28.2745 33.7092C26.4656 35.5126 24.1192 37.8331 21.2333 40.6706C20.3659 41.5233 19.2065 42 18 42C16.7935 42 15.6341 41.5233 14.7667 40.6706L7.54979 33.5326C6.64018 32.6267 5.88355 31.8637 5.27163 31.2415C2.75441 28.682 1.04021 25.4211 0.345778 21.871C-0.348651 18.321 0.0078849 14.6413 1.3703 11.2973C2.73271 7.95328 5.03982 5.09511 7.99987 3.08421C10.9599 1.07331 14.44 0 18 0C21.56 0 25.0401 1.07331 28.0001 3.08421C30.9602 5.09511 33.2673 7.95328 34.6297 11.2973C35.9921 14.6413 36.3487 18.321 35.6542 21.871C34.9598 25.4211 33.2456 28.682 30.7284 31.2415ZM23.1683 18.8782C23.1683 17.4846 22.6237 16.148 21.6545 15.1626C20.6853 14.1771 19.3707 13.6235 18 13.6235C16.6293 13.6235 15.3147 14.1771 14.3455 15.1626C13.3763 16.148 12.8317 17.4846 12.8317 18.8782C12.8317 20.2719 13.3763 21.6084 14.3455 22.5939C15.3147 23.5793 16.6293 24.133 18 24.133C19.3707 24.133 20.6853 23.5793 21.6545 22.5939C22.6237 21.6084 23.1683 20.2719 23.1683 18.8782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.615c577c16c55cd87d05e6c97c17b7dd.svg";
export { ForwardRef as ReactComponent };